import { trackEvent, trackPageview } from '@tiger/track';

const config = {
    eventType: {
        signup: 'signup',
        openacc: 'openacc'
    },

    signup_email: ['signup_email', 'signup_signup'],
    signup_phone: ['signup_phone', 'signup_signup'],

    signup_verfication: ['signup_verfication'],

    signup: ['signup_signup', 'signup_verfication', 'signup_phone', 'signup_email'],

    /**
     * @param personalInfo step = 1
     *  国家地区/国籍	openacc_residence
     *  个人基础信息	openacc_basic
     *  居住地	openacc_social
     *  婚姻&职业	openacc_regulation
     */
    personalInfo: ['openacc_residence', 'openacc_basic', 'openacc_home', 'openacc_social'],

    /**
     * @param job step = 2
     *  详细职业	openacc_career
     *  收入来源	openacc_income
     *  其他收入来源	openacc_otherincome
     *  合规信息确认	openacc_regulation
     *  Questionnaire	openacc_questionnaire
     */
    job: ['openacc_career', 'openacc_income', 'openacc_otherincome', 'openacc_regulation', 'openacc_questionnaire'],

    /**
     * @param account step = 3
     * 账户类型/交易类型	openacc_type
     */
    account: ['openacc_type'],

    /**
     * @param invest step = 4
     * 交易经验/资产信息	openacc_preference
     */
    invest: ['openacc_preference'],

    /**
     * @param contact step = 5
     * 安全手机号/安全邮箱	openacc_security
     */
    contact: ['openacc_security'],

    /**
     * @param agreement step = 9
     *  签名	openacc_sign
     *  协议	openacc_agreements
     *  完成开户	openacc_complete
     */
    agreement: ['openacc_sign', 'openacc_agreements', 'openacc_complete']
};

type IEventListType =
    | 'personalInfo'
    | 'signup'
    | 'job'
    | 'account'
    | 'invest'
    | 'contact'
    | 'agreement'
    | 'signup_phone'
    | 'signup_email'
    | 'signup_verification';

export const reportEventList = (type: IEventListType, category: string = 'opencc') => {
    config[type]?.forEach(action => {
        trackEvent(category, action, action);
    });
};

export const reportPageview = (path?: string, title?: string) => {
    trackPageview(path, title);
};
